import { TypeDocClient } from 'front-office/view-models/type-doc-list';
import { HeadCell } from 'shell/components/shared/table/types';
import * as yup from 'yup';

export const headCells: HeadCell<TypeDocClient, keyof TypeDocClient>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'typeDoc',
    label: 'Tipo documento',
  },
  {
    id: 'description',
    label: 'Descrizione documento',
  },
  {
    id: 'typeRights',
    label: 'Tipo diritti',
  },
  {
    id: 'mode',
    label: 'Modalità rilascio',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchemaFilter = yup.object({});
